import { uriTransformer } from 'react-markdown';

/**
 * react-markdown 8's default `uriTransformer` only allows http, https,
 * mailto and tel URIs, rewriting anything else (including our internal
 * `guide:` scheme) to `javascript:void(0)`. Let `guide:` links through
 * unchanged and defer everything else to the default transformer.
 */
export const helpLinkUri = (uri: string): string =>
  uri.startsWith('guide:') ? uri : uriTransformer(uri);
